var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 26",
    width: 24,
    height: 24,
    transform: "translate(291 279)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-291 -279)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(293.924 280.795)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 218",
    transform: "translate(-0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 1",
    d: "M13.535,20.41H4.621a3.033,3.033,0,0,1-3.029-3.029V4.069H.568a.566.566,0,1,1,0-1.133H4.816V2.244A2.247,2.247,0,0,1,7.06,0h4.034a2.249,2.249,0,0,1,2.248,2.244v.692h4.244a.566.566,0,1,1,0,1.133H16.564V17.381A3.033,3.033,0,0,1,13.535,20.41ZM9.078,6.1a.567.567,0,0,0-.565.568v10a.566.566,0,1,0,1.133.008V6.67A.562.562,0,0,0,9.078,6.1Zm3.7.621a.565.565,0,0,0-.565.564v8.769a.559.559,0,0,0,.565.564.567.567,0,0,0,.568-.564V7.287A.567.567,0,0,0,12.775,6.723Zm-7.394,0a.565.565,0,0,0-.565.564v8.769a.566.566,0,0,0,1.133,0V7.287A.567.567,0,0,0,5.381,6.723Zm1.68-5.59A1.112,1.112,0,0,0,5.949,2.244v.692H12.21V2.244a1.114,1.114,0,0,0-1.115-1.111Z",
    transform: "translate(0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFilled);
export default __webpack_public_path__ + "static/media/trash-filled.ae1edb9e.svg";
export { ForwardRef as ReactComponent };